import React from 'react';
import { useTheme } from '../../../../theme';
import cn from 'classnames';
export var Group = function (props) {
    var css = useTheme('Communications').NotificationCard;
    return React.createElement("div", { className: cn(css.card__group, props.className) }, props.children);
};
